import { render, staticRenderFns } from "./ViewPriceList.vue?vue&type=template&id=43da4e66&"
import script from "./ViewPriceList.vue?vue&type=script&lang=js&"
export * from "./ViewPriceList.vue?vue&type=script&lang=js&"
import style0 from "./ViewPriceList.vue?vue&type=style&index=0&id=43da4e66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports